import React from 'react'

import { withTranslation as translate } from 'react-i18next'
import Error from './Error'
import fieldErrorKey from './fieldErrorKey'

const Address = ({ street, postalCode, city, onChange, t, errors, inputRefs }) => {
  const streetError = errors.user && errors.user.address && errors.user.address.street
  const postalCodeError = errors.user && errors.user.address && errors.user.address.postalCode
  const cityError = errors.user && errors.user.address && errors.user.address.postalLocation

  return (
    <div>
      <div>
        <input
          type='text'
          className={streetError ? 'error' : ''}
          ref={(input) => (inputRefs.street = input)}
          name='street'
          value={street}
          onChange={onChange}
          placeholder={t('signup.profile.street')}
          id='street'
          autoComplete='street-address'
        />
        {streetError && <Error messageKey={fieldErrorKey(streetError)} />}
      </div>
      <div>
        <input
          type='text'
          className={`code ${postalCodeError ? 'error' : ''}`}
          ref={(input) => (inputRefs.postalCode = input)}
          name='postalCode' value={postalCode}
          onChange={onChange}
          placeholder={t('signup.profile.postal_code')}
          id='postal-code'
          autoComplete='postal-code'
        />
        {postalCodeError && <Error messageKey={fieldErrorKey(postalCodeError)} />}

        <input
          type='text'
          className={cityError ? 'error' : ''}
          ref={(input) => (inputRefs.postalLocation = input)}
          name='city' value={city}
          onChange={onChange}
          placeholder={t('signup.profile.city')}
          id='city'
          autoComplete='address-level2'
        />
        {cityError && <Error messageKey={fieldErrorKey(cityError)} />}
      </div>
    </div>
  )
}

export default translate()(Address)
